import { toDisplayKmh } from '../../constants.ts';
import type { BoatHit } from '../host.ts';

/**
 * A boat-to-boat hit, in the same shape a map contact logs. `name` is the other
 * seat; the line is written from the point of view of the boat whose log it is.
 */
export function formatBoatContactLog(hit: BoatHit, name: string, struck: boolean): string {
  const kmh = Math.round(toDisplayKmh(hit.closingSpeed));
  const where = struck ? placeOnHull(hit.intoAlong) : placeOnHull(hit.fromAlong);

  const tier = hit.rearEnd ? `${hit.severity} · from behind` : hit.severity;

  return `${struck ? 'struck by' : 'hit'} ${name} · ${kmh} km/h · ${where} · ${tier}`;
}

function placeOnHull(along: number): string {
  if (along > 0.75) {
    return 'bow';
  }

  if (along < 0.25) {
    return 'stern';
  }

  return 'beam';
}
